import "./HtmlContent.css";

import type { CSSProperties, ReactNode } from "react";

export interface HtmlContentProps {
  children?: ReactNode;
  html?: string;
  style?: CSSProperties;
}

export function HtmlContent({ children, html = "", style }: HtmlContentProps) {
  return children ? (
    <div className="HtmlContent" style={style}>
      {children}
    </div>
  ) : (
    <div
      className="HtmlContent"
      dangerouslySetInnerHTML={{ __html: html }}
      style={style}
    />
  );
}
